module.exports = __webpack_public_path__ + "img/cardLayout-02.4e58560f.png";